import { Avatar, Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SecondaryButtonStyled } from '~/styles';
import { width } from '../list/styled';
import { AvatarRegularStyledProps } from './types';

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${theme.colors.grey[200]};
  `}
`;
export const UserDetailContainerStyled = styled(Box).attrs({
  pt: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  width: calc(100% - ${width});
  ${({ theme }) => css`
    margin: ${theme.spacings[400]};
    background-color: ${theme.colors.white};
  `}
`;

export const SepartorStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[700]};
  `}
`;

export const UserDetailFooterStyled = styled(Box).attrs({
  py: { sm: '500' },
  pr: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})``;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const FooterStyled = styled(Box).attrs({
  pr: { sm: '500' },
  py: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
  gap: { sm: '500' },
})`
  width: 100%;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadowInverted};
  z-index: 1;
`;

export const CancelButtonStyled = styled(SecondaryButtonStyled)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[400]};
    padding: ${theme.spacings[400]} ${theme.spacings[600]};
  `}
`;
